import { useTranslation } from "react-i18next";
import { ConfirmButton } from "@/components/ConfirmButton";
import { Spin } from "@/components/ui";

interface Props {
  deleted: boolean;
  canWrite: boolean;
  busy?: boolean;
  onDelete: () => void;
  onRestore?: () => void;
  deleteLabel?: string;
}

/** Per-row delete (when live) / restore (when soft-deleted). */
export function RowActions({
  deleted,
  canWrite,
  busy,
  onDelete,
  onRestore,
  deleteLabel,
}: Props) {
  const { t } = useTranslation();
  if (!canWrite) return null;

  if (deleted) {
    return (
      <div className="flex items-center gap-2">
        <span className="rounded-full bg-red-500/15 px-2 py-0.5 text-xs text-red-700">
          {t("common.deletedBadge")}
        </span>
        {onRestore && (
          <button
            type="button"
            className="rounded-md border border-olive-600 px-2.5 py-1 text-xs font-medium text-sand-muted hover:text-sand disabled:opacity-50"
            onClick={onRestore}
            disabled={busy}
            aria-busy={busy || undefined}
          >
            {busy ? <Spin className="mr-1.5" /> : null}
            {t("common.restore")}
          </button>
        )}
      </div>
    );
  }

  return (
    <ConfirmButton
      label={deleteLabel ?? t("common.delete")}
      busy={busy}
      onConfirm={onDelete}
    />
  );
}
